module.exports = __webpack_public_path__ + "static/media/icomoon.e5c2c974.woff";